<template>
  <div class="container-root">
    <div class="loader" v-if="isLoading"></div>
    <div v-else>
      <div class="header-group">
        <h2 style="margin: 0px; font-weight: bold">MY TIME OFF</h2>
      </div>
      <div class="vertical-space">
        <Card :title="summary.title">
          <div class="content-summary">
            <div class="period-title">{{ period }}</div>
            <div style="padding: 10px">
              <div class="summary-title">Summary</div>
              <div class="summary-group">
                <div
                  v-for="(value, key) in summary.stats"
                  :key="key"
                  class="summary-elem"
                >
                  <div style="font-size: 1.5em">{{ `${value.amt} Days` }}</div>
                  <div style="text-transform: uppercase">{{ value.text }}</div>
                </div>
              </div>
            </div>
            <div class="footer">
              <button
                class="button-square green"
                style="font-size: 18px"
                @click="showDetails"
              >
                <i class="fas fa-plus"></i>
                <div style="margin-left: 5px">Request Time Off</div>
              </button>
            </div>
          </div>
        </Card>
      </div>
      <div class="vertical-space">
        <CalendarPicker :selectedDays="[]" :profile="profile"></CalendarPicker>
      </div>
      <!-- <div class="vertical-space">
        <Table
          :title="'Time Off History'"
          :model="list.table"
          :isLoading="list.isLoading"
          :actions="list.actions"
          @onAction="onAction"
        ></Table>
      </div>-->
    </div>
    <!-- time off request modal -->
    <Modal :isShowing.sync="details.isShowing" :title="'Request Time Off'">
      <div class="req-group">
        <div class="req-questions">
          <div class="req-question-group column">
            <div class="req-question-title">
              1. Select a date you want to take off
            </div>
            <CalendarPicker
              :selectedDays.sync="details.model.dates"
              :enableEvents="true"
              :profile="profile"
            ></CalendarPicker>
          </div>
          <div class="req-question-group">
            <div class="req-question-title">2. Select your time off type</div>
            <select v-model="details.model.type" class="req-control">
              <option
                v-for="(option, optionIdx) in details.timeOffs"
                :key="optionIdx"
              >
                {{ option }}
              </option>
            </select>
          </div>
          <div class="req-question-group">
            <div class="req-question-title">3. Specify time off reason</div>
            <textarea
              class="req-control"
              rows="4"
              cols="50"
              v-model="details.model.reason"
            ></textarea>
          </div>
          <div class="req-question-group">
            <div class="req-question-title">4. Supporting document</div>
            <div style="display: flex">
              <label for="doc" class="upload">
                <i class="fa fa-upload"></i>
                Upload
              </label>
              <div class="upload-text" v-if="supportingDocFile">
                {{ supportingDocFile.name }}
              </div>
              <input
                id="doc"
                style="display: none"
                type="file"
                accept="application/pdf, image/*"
                @change="uploadFile($event.target.files[0])"
              />
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="loader" v-if="isSubmitting"></div>
          <button class="button dark-blue" @click="submit" v-else>
            Request Time Off
          </button>
        </div>
      </div>
    </Modal>
    <Notif v-if="notif" :data.sync="notif"></Notif>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { utils, http } from '../digilib_web/core/digitify';
import { constants } from '../js/regents';
import Modal from '../digilib_web/vue/modal';
import Notif from '../digilib_web/vue/notif';
import Card from './common/card';
import CalendarPicker from './common/calendar_picker';

function initialData() {
  return {
    notif: null,
    supportingDocFile: null,
    isLoading: false,
    isSubmitting: false,
    summary: { title: 'Sickness, Absence, Excused Request', stats: null },
    period: null,
    details: {
      isShowing: false,
      timeOffs: constants.TIMEOFF_TYPE,
      model: { type: 'Sickness', reason: null, dates: [], supporting_doc: '' },
      events: []
    },
    list: {
      isLoading: false,
      table: {},
      data: [],
      actions: ['Delete']
    }
  };
}

export default {
  props: {
    profile: Object
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      let year = dayjs().year();
      // set the period label
      this.period = `Period 1 January ${year} - 31 December ${year}`;
      // get the calendar events for the current month
      this.isLoading = true;
      let endpoint = `employees/timeoffs/annually/${year}?where=id_employee,=,${
        this.profile.id
      }|is_approved,=,true`;
      // load the timeoffs of the employee annually
      http.get(endpoint).then(json => {
        // console.log(json);

        this.summary.stats = {
          Sickness: { amt: 0, text: 'Sickness' },
          Excuse: { amt: 0, text: 'Excuse' },
          Absent: { amt: 0, text: 'Absent' },
          Maternity: { amt: 0, text: 'Maternity' },
          'Special Leave': { amt: 0, text: 'Special Leave' },
          'Early Leave Before 2 PM': { amt: 0, text: 'Early Leave < 2 PM' },
          'Early Leave After 2 PM': { amt: 0, text: 'Early Leave > 2 PM' }
        };
        json.data.forEach(elem => {
          elem.dates.forEach(date => {
            // add the stats
            let type = elem.type;
            // console.log(type);

            this.summary.stats[type].amt++;
            // add the events
            let status =
              elem.is_approved === null
                ? 'Pending'
                : elem.is_approved
                ? 'Approved'
                : 'Rejected';
            let evName = `${elem.type} (${status})`;
            let ev = { date: date, name: evName };
            this.details.events.push(ev);
          });
        });
        // the page is ready
        this.isLoading = false;
        // get history data
        // let idEmp = this.profile.id
        // let endpoint = `employees/timeoffs/annually/${year}?where=id_employee,=,${idEmp}`
        // http.get(endpoint).then(json => {
        //   this.list.data = json.data
        //   // generate the table data
        //   this.list.table = utils.toTable(this.list.data, {
        //     employee_name: { title: 'name' },
        //     dates: { title: 'date requested', type: 'daterange' },
        //     days_count: { title: 'no. of days' },
        //     type: { title: 'type' }
        //   })
        // })
      });
    },
    submit() {
      let payload = this.payload();
      if (!payload.dates || payload.dates.length === 0) {
        alert('Please select a date you want to take off!');
        return;
      }
      // submit
      this.isSubmitting = true;
      http.post('employees/timeoffs', payload).then(json => {
        if (json.success) {
          if (this.supportingDocFile) {
            let formData = new FormData();
            formData.append('file', this.supportingDocFile);
            let id = json.data.id;
            http.post(`employees/timeoffs/${id}/mc`, formData).then(json => {
              if (json.success) {
                this.notif = utils.notif('Time Off Submitted!', json);
                this.resetDetails();
              }
            });
          } else {
            this.notif = utils.notif('Time Off Submitted!', json);
            this.resetDetails();
          }
        }
      });
    },
    uploadFile(file) {
      if (file) {
        // limit the file size to 2 mb for now
        if (file.size > 5000000) {
          alert(`File size can't be more than 5 mb`);
          return;
        }
        this.supportingDocFile = file;
      }
    },
    resetDetails() {
      this.resetDetailsModel();
      this.reload();
      this.details.isShowing = false;
    },
    resetDetailsModel() {
      this.details.model = { type: 'Sickness', reason: null, dates: [] };
      this.isSubmitting = false;
    },
    showDetails() {
      this.resetDetailsModel();
      this.details.isShowing = true;
    },
    payload() {
      let payload = Object.assign({}, this.details.model);
      payload.id_employee = this.profile.id;
      return payload;
    },
    onAction(action, itemId) {
      switch (action) {
        case 'Delete':
          if (confirm('Are you sure to delete?')) {
            this.list.isLoading = true;
            http.del(`employees/timeoffs/${itemId}`).then(json => {
              this.notif = utils.notif('Time off deleted!', json);
              this.list.isLoading = false;
              this.reload();
            });
          }
          break;
        default:
          break;
      }
    }
  },
  data() {
    return initialData();
  },
  components: {
    Card,
    Modal,
    CalendarPicker,
    Notif
  }
};
</script>

<style scoped>
.vertical-space {
  margin-top: 15px;
}
.content-summary {
  display: flex;
  flex-flow: column;
}
.period-title {
  font-size: 1em;
  color: rgb(43, 42, 42);
}
.summary-title {
  font-size: 0.9em;
  color: #203368;
  text-transform: uppercase;
  font-weight: bold;
  margin: 10px 0;
}
.summary-group {
  display: flex;
  justify-content: space-between;
}
.summary-elem {
  background-color: rgb(34, 52, 107);
  color: white;
  width: 400px;
  height: 100px;
  padding: 10px;
  border-radius: 0.3em;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.summary-elem:nth-child(even) {
  margin: 0 50px;
}
.footer {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.req-group {
  display: flex;
  flex-flow: column;
}
.req-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.1em;
}
.req-questions {
  margin-top: 10px;
}
.req-question-group {
  display: flex;
  margin-bottom: 20px;
}
.req-question-group.column {
  flex-flow: column;
}
.req-question-group > select {
  height: 32px;
}
.req-question-title {
  width: 300px;
  margin-bottom: 10px;
}
.req-control {
  padding: 0.5em;
  border: 1px solid #cecece;
  font-size: 0.9rem;
  border-radius: 0.2rem;
  min-width: 200px;
}

@media screen and (max-width: 768px) {
  .summary-elem:nth-child(even) {
    margin: 0 0 10px 0;
  }
  .summary-elem:nth-child(odd) {
    margin: 0 0 10px 0;
  }
  .summary-elem {
    height: 70px;
    width: auto;
    flex: 1 1 auto;
  }
  .summary-group {
    flex-flow: column;
  }
  .req-question-group {
    flex-flow: column;
  }
  .req-control {
    flex: 1 1 auto;
  }
}
</style>
